import { useMediaQuery } from "@uidotdev/usehooks";

export function useTabMediaQuery() {
  return useMediaQuery("(max-width: calc(64rem - 1px))");
}

export function useMobileMediaQuery() {
  return useMediaQuery("(max-width: calc(48rem - 1px))");
}
